"use client";

import Image from "next/image";
import { PropsWithChildren } from "react";
import { Card } from "@/components/headToHead/Card";
import styles from "./TeamContainer.module.scss";

interface TeamContainerProps {
  teamName: string;
  teamColor: string;
  teamIcon: string;
  showColumHeaders?: boolean;
}

export default function TeamContainer({
  teamName,
  teamColor,
  teamIcon,
  showColumHeaders = false,
  children,
}: PropsWithChildren<TeamContainerProps>) {
  return (
    <Card className={styles.teamContainer}>
      <div className={styles.teamBanner} style={{ backgroundColor: teamColor }}>
        <p>
          <Image width={28} height={25} src={teamIcon} alt={teamName} />
          {teamName}
        </p>
      </div>
      <div className={styles.listContainer}>
        {showColumHeaders && (
          <div className={styles.listHeader}>
            <span>Name</span>
            <span>Status</span>
          </div>
        )}
        <div>{children}</div>
      </div>
    </Card>
  );
}
